import styled from "styled-components";

const Divider = styled.hr`
    margin: 0;
    padding: 0;
    border: none;
    height: 1px;
    width: 100%;
    background-color: currentColor;
    opacity: .25;
`;

export default Divider;